import React from 'react';
import CustomSelect from '../../ui/CustomSelect';

export default function KPIStats({ totalWeight, filterDept, onFilterChange, departments }) {
  const filterOptions = [
    { value: 'all', label: 'Semua Departemen' },
    ...departments.map(d => ({ value: d.id, label: d.name })),
  ];

  // Format persentase tanpa desimal yang tidak perlu
  const formatPercentage = value => {
    if (value === null || value === undefined || value === '') return '0';
    const num = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (isNaN(num)) return '0';
    // Jika angka bulat, tampilkan tanpa desimal
    if (Number.isInteger(num)) {
      return num.toString();
    }
    // Jika ada desimal, hapus trailing zeros
    return num.toString().replace(/\.?0+$/, '');
  };

  const formattedWeight = formatPercentage(totalWeight);
  const weightNum = typeof totalWeight === 'string' ? parseFloat(totalWeight) : Number(totalWeight);
  const diff = weightNum !== 100 ? formatPercentage(Math.abs(100 - weightNum)) : '0';

  return (
    <div className="grid md:grid-cols-4 gap-4">
      <div className="md:col-span-3 bg-white rounded-lg border shadow-sm p-4">
        <p className="text-sm text-gray-500 mb-2">Total Bobot KPI</p>
        <div className="flex items-center gap-3">
          <div className="flex-1 h-3 bg-gray-200 rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${weightNum > 100 ? 'bg-red-500' : 'bg-emerald-500'}`}
              style={{ width: `${Math.min(weightNum, 100)}%` }}
            />
          </div>
          <span className={`font-bold ${weightNum > 100 ? 'text-red-600' : 'text-green-600'}`}>
            {formattedWeight}%
          </span>
        </div>
        {weightNum !== 100 && (
          <p className="text-xs text-amber-600 mt-1">
            {weightNum < 100 ? `Kurang ${diff}% lagi` : `Kelebihan ${diff}%`}
          </p>
        )}
      </div>
      <div className="bg-white rounded-lg border shadow-sm p-4">
        <CustomSelect
          value={filterDept}
          onChange={onFilterChange}
          options={filterOptions}
          placeholder="Filter Departemen"
          width="w-full"
        />
      </div>
    </div>
  );
}
